import {Component, inject, Input, ViewChild} from '@angular/core';
import {NgClass} from '@angular/common';

import {ValLangueService} from '../../../../../val-definitions-communes-lib/src/public-api';

import {BoiteDialogueGeneriqueComponent} from "../boite-dialogue-generique/boite-dialogue-generique.component";
import {SimpleImageComponent} from "../simple-image/simple-image.component";
import {SimpleLibelleComponent} from '../simple-libelle/simple-libelle.component';
import {SimpleBoutonComponent} from "../simple-bouton/simple-bouton.component";
import {FonteIconeComponent} from "../fonte-icone/fonte-icone.component";

//Type d’une boîte de dialogue messages : teinte l’en-tête et active l’apparition en fondu
export type TypeBoiteDialogueMessages = "succes" | "erreur";

//Icone fonte par défaut de chaque type
const ICONES_TYPE: Record<TypeBoiteDialogueMessages, string> =
{
  succes: "fas fa-check-circle",
  erreur: "fas fa-exclamation-circle"
};

//Composant boîte de dialogue messages
@Component (
{
  selector: 'val-boite-dialogue-messages',
  imports:
  [
    NgClass,
    BoiteDialogueGeneriqueComponent,
    SimpleImageComponent,
    SimpleLibelleComponent,
    SimpleBoutonComponent,
    FonteIconeComponent
  ],
  templateUrl: './boite-dialogue-messages.component.html',
  styleUrl: './boite-dialogue-messages.component.scss',
})
export class BoiteDialogueMessagesComponent
{
  private valLangueService = inject (ValLangueService);

  //Création
  constructor ()
  {
    this.titre = "";
    this.icone = "";
    this.iconeFonte = "";
    this.messages = [];
  }

  @ViewChild ("boiteDialogue")
  public boiteDialogue!: BoiteDialogueGeneriqueComponent<void>;

  //Titre
  @Input ()
  public titre: string;

  //Icone sous forme d’image (nom de fichier dans assets/)
  @Input ()
  public icone: string;

  //Icone sous forme de fonte d’icônes (ex: "fas fa-info-circle"), prioritaire sur icone si renseignée
  @Input ()
  public iconeFonte: string;

  //Couleur de l’icone fonte (si non renseignée, la couleur par défaut du composant s’applique)
  @Input ()
  public iconeCouleur?: string;

  //Messages
  @Input ()
  public messages: string[];

  //Type (succès, erreur) : sans type, le rendu historique est conservé
  @Input ()
  public type?: TypeBoiteDialogueMessages;

  //Classes posées sur la boîte de dialogue selon le type
  public get ClassesType () : string[]
  {
    return this.type ? ["val-boite-dialogue-messages-type", `val-boite-dialogue-messages-${this.type}`] : [];
  }

  //Icone fonte affichée : celle fournie, sinon celle du type s’il n’y a pas d’icone image
  public get IconeFonteAffichee () : string
  {
    if (this.iconeFonte || !this.type || this.icone)
      return this.iconeFonte;

    return ICONES_TYPE[this.type];
  }

  //Libellé du bouton de fermeture : la clé du scope valcomposantslib, chargé par le bandeau
  //d’application, ou « Ok » si l’application ne la porte pas
  public get TexteOk () : string
  {
    return this.valLangueService.TraduireOuDefaut ("valcomposantslib.boite-dialogue-messages.ok", "Ok");
  }

  //Ouvre la boîte de dialogue
  public async Ouvrir () : Promise<void>
  {
    let operation: Promise<void>;

    operation = this.boiteDialogue.Ouvrir ();

    return operation;
  }

  //Ferme la boîte de dialogue
  public Fermer () : void 
  {
    this.boiteDialogue.fonctionRetour ();
    this.boiteDialogue.Fermer ();
  }
}
